// src/styles/settings/constants.ts

// Sidebar Configuration Constants
export const ASIDE_WIDTH_PX = 259; // Sidebar width in pixels
export const SPACER_PX = 13;        // Spacer value in pixels

// Breakpoint Sizes
export const MOBILE_BREAKPOINT_SIZE = 768;             // Mobile breakpoint in pixels
export const ASIDE_MINIMIZE_BREAKPOINT_SIZE = 768;    // Minimize breakpoint in pixels
